import axios from 'axios';
import kali from 'kali';

import {
	getSession,
} from 'Vulture/Session.js';

import {
	broncoURL,
} from 'Vulture/ENV.js';

export const registerListingIntegration = async ({
	accountUUID,
	listingConfigUUID,
	provider,
	integrationList,
	email = '',
	authCode = '',
	key = '',
	mallID = '',
	mapID = '',
	loyaltyClubSlug = '',
}) => {
	const session = getSession();

	let url = `${broncoURL}/listing_config/register_integration`;
	let body = {
		account_uuid:        accountUUID,
		listing_config_uuid: listingConfigUUID,
		provider,
		integration_list:    integrationList,
		email,
		auth_code:           authCode,
		key,
		mall_id:             mallID,
		map_id:              mapID,
		loyalty_club_slug:   loyaltyClubSlug,
	};

	const headers = {
		headers: {
			'X-Auth-Session': session.session,
		},
	};

	try {
		let res = await axios.post(url, body, headers);
		if (res.status !== 200) {
			debugger;
		}

		return res.data;
	} catch (err) {
		console.error(err);

		// Surface the server's message (e.g. a bad MallMaverick Property ID) so the
		// modal can render it inline.
		let serverMsg = err?.response?.data;
		if (typeof serverMsg === 'string' && serverMsg) {
			throw new Error(serverMsg);
		}

		throw new Error('The credentials could not be saved.');
	}
};

export const crawlListingIntegration = async (accountUUID, listingConfigUUID, provider) => {
	const session = getSession();

	let url = `${broncoURL}/integrations/crawl_listing`;
	let body = {
		account_uuid:        accountUUID,
		listing_config_uuid: listingConfigUUID,
		provider,
	};

	const headers = {
		headers: {
			'X-Auth-Session': session.session,
		},
	};

	try {
		let res = await axios.post(url, body, headers);
		if (res.status !== 200) {
			debugger;
		}

		return res.data;
	} catch (err) {
		console.error(err);

		// Surface the server's message (crawl startup errors come back as a JSON
		// string) so the modal can render it.
		let serverMsg = err?.response?.data;
		if (typeof serverMsg === 'string' && serverMsg) {
			throw new Error(serverMsg);
		}

		throw new Error('The crawler could not be started.');
	}
};

export const deleteIntegrationListingConfig = async (listingConfigUUID) => {
	const session = getSession();

	let url = `${broncoURL}/listing_config/delete_integration`;
	let body = {
		listing_config_uuid: listingConfigUUID,
	};

	const headers = {
		headers: {
			'X-Auth-Session': session.session,
		},
	};

	let res = await axios.post(url, body, headers);

	return res.data;
};

export const fetchListingColumnTypes = async () => {
	const url = `${broncoURL}/r/list/listing_column_type`;
	let sessionKey = getSession().session;

	let retVal;

	await new kali({
		body: {
			'skip_auth_filter': true,
		},
		headers: {
			'content_type':   'application/json',
			'X-Auth-Session': sessionKey,
		},
		method: 'POST',
	}).post(url, {
		success: (_kali, res, contents) => {
			retVal = true;
			if (contents && contents.data) {
				retVal = contents;
			}
		},

		failure: (_kali, res, err) => {
			console.error(err);
		},
	});

	return retVal;
};

export const fetchPlacewiseMalls = async (email, authCode) => {
	const url = `${broncoURL}/integrations/malls/placewise`;
	let sessionKey = getSession().session;

	let malls;

	try {
		const res = await fetch(url, {
			body: JSON.stringify({
				email,
				auth_code: authCode,
			}),
			headers: {
				'Content-Type':   'application/json',
				'X-Auth-Session': sessionKey,
			},
			method: 'POST',
		});

		if (res.status !== 200) {
			throw new Error('Could not fetch malls.');
		}

		malls = await res.json();
	} catch (err) {
		console.error(err);
		alert('Could not fetch malls.');
	}

	return malls;
};

export const updateListingConfigLabel = async (listingConfigUUID, listingColumnUUID) => {
	const url = broncoURL + `/v1/listing_config/${listingConfigUUID}/label/${listingColumnUUID}`;
	return fetch(url, {
		method:  'PUT',
		headers: {
			'Content-Type':   'application/json',
			'X-Auth-Session': getSession().session,
		},
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		});
};

